import * as yup from "yup";

export const defaultvoterinfovalues = {
  residence: "Urban",
  caste: "",
  qualification: "",
  disability: false,
  disabilityPercentage: "",
  minority: false,
  bpl: false,
  familyIncome: "",
  parentIncome: "",
  isStudent: false,
  employement: "",
  governmentEmployee: false,
  occupation: "",
  affected: "",
};

const booleanTransformer = (val: any) => {
  if (typeof val === "string") {
    return val.trim().toLowerCase() === "yes";
  }
  return val;
};

export const voterEligibilitySchema = yup.object().shape({
  residence: yup.string().required("Residence is required"),

  marital: yup.string().when(["gender", "age"], ([gender, age], schema) => {
    return gender === "Female" && age > 18
      ? schema.required("Marital status is required")
      : schema.notRequired();
  }),

  caste: yup.string().required("Caste is required"),
  qualification: yup.string().required("Qualification is required"),

  disability: yup
    .boolean()
    .transform(booleanTransformer)
    .required("Disability status is required"),

  disabilityPercentage: yup.string().when("disability", ([value], schema) => {
    return value === true
      ? schema.required("Disability Percentage is required")
      : schema.notRequired();
  }),

  minority: yup
    .boolean()
    .transform(booleanTransformer)
    .required("Minority field is required"),

  isStudent: yup
    .boolean()
    .transform(booleanTransformer)
    .required("Student status is required"),

  parentIncome: yup.string().when("isStudent", ([value], schema) => {
    return value === true
      ? schema.required("Income is required for students")
      : schema.notRequired();
  }),

  employement: yup.string().when("isStudent", ([value], schema) => {
    return value === false
      ? schema.required("Employment status is required")
      : schema.notRequired();
  }),

  governmentEmployee: yup
    .boolean()
    .transform(booleanTransformer)
    .when("employement", ([value], schema) => {
      return value === "Employed"
        ? schema.required("Government employment status is required")
        : schema.notRequired();
    }),

  occupation: yup
    .string()
    .when(
      ["employement", "governmentEmployee"],
      ([employement, governmentEmployee], schema) => {
        if (employement === "Self-Employed") {
          return schema.notRequired();
        }
        if (employement === "Employed" && governmentEmployee === false) {
          return schema.notRequired();
        }
        return schema.notRequired();
      },
    ),

  bpl: yup
    .boolean()
    .transform(booleanTransformer)
    .required("BPL Category is required"),

  familyIncome: yup.string().when("bpl", ([value], schema) => {
    return value === false
      ? schema.required("Family income is required")
      : schema.notRequired();
  }),

  affected: yup.string().required("Affected By is required"),
});
